<span
  *ngIf="node"
  [ngSwitch]="getTopLevelTag(node).summary"
  class="!text-slate-500"
>
  <!-- Expenditure progress -->
  <span *ngSwitchCase="'expenditureProgress'">
    <span *ngIf="withCaptions" class="align-middle">
      <tag-node-icon [node]="node" [tags]="tags"></tag-node-icon>

      <span class="hidden"
        >{{
          getTopLevelTag(node).isPeriodic && !showForFixed
            ? "Periodic"
            : "Fixed "
        }}
      </span>
      <span matTooltip="Actual expenditure / Planned expenditure"
        >Expenditure progress:
      </span>
    </span>

    <!-- Periodic -->
    <span
      *ngIf="
        getTopLevelTag(node).isPeriodic && !showForFixed;
        else nonPeriodicValues
      "
      [ngClass]="{
        'text-red-400':
          periodService.getActualExpenditureForPeriod(node.id!) >
          getTagPeriod(node)?.plannedExpenditure!
      }"
    >
      <!-- Expenditure -->

      <!-- Actual -->
      <span>{{
        periodService.getActualExpenditureForPeriod(node.id!)
          ? (periodService.getActualExpenditureForPeriod(node.id!)
            | prefundCurrency)
          : (0 | prefundCurrency)
      }}</span>

      <!-- / -->
      <span class="mx-1">/</span>

      <!-- Planned -->
      <span
        (click)="plannedAmountClicked.emit(node)"
        [ngClass]="{
          'underline underline-offset-4 decoration-dotted cursor-pointer':
            withCaptions
        }"
        >{{
          getTagPeriod(node)?.plannedExpenditure
            ? (getTagPeriod(node)?.plannedExpenditure | prefundCurrency)
            : "-"
        }}</span
      >
    </span>

    <!-- Fixed Tag -->
    <ng-template #nonPeriodicValues>
      <span
        *ngIf="!showForFixed; else noPlanForFixed"
        class="whitespace-nowrap"
        [ngClass]="{
          'text-red-400': node.plannedExpenditure! < node.actualExpenditure!
        }"
      >
        <!-- Actual -->
        <span>{{ node.actualExpenditure ?? 0 | prefundCurrency }}</span>

        <!-- / -->
        <span class="mx-1">/</span>

        <!-- Planned -->

        <span
          *ngIf="node.plannedExpenditure"
          [ngClass]="{
            'underline underline-offset-4 decoration-dotted cursor-pointer':
              withCaptions
          }"
          (click)="plannedAmountClicked.emit(node)"
          >{{ node.plannedExpenditure | prefundCurrency }}
        </span>
        <span *ngIf="!node.plannedExpenditure">-</span>
      </span>
      <ng-template #noPlanForFixed>-</ng-template>
    </ng-template>

    <span *ngIf="withCaptions" class="ml-2">
      {{ getTopLevelTag(node).isPeriodic && !showForFixed ? "Sum:" : "Sum:" }}
      <span *ngIf="!getTopLevelTag(node).isPeriodic || showForFixed">{{
        node.runningBalance | prefundCurrency
      }}</span>
      <span *ngIf="getTopLevelTag(node).isPeriodic && !showForFixed">{{
        periodService.gerRunningBalanceForPeriod(node.id!) | prefundCurrency
      }}</span>
    </span>
  </span>
  <!-- Income progress -->
  <span *ngSwitchCase="'incomeProgress'">
    <span *ngIf="withCaptions" class="align-middle">
      <tag-node-icon [node]="node" [tags]="tags"></tag-node-icon>
      <span>{{
        getTopLevelTag(node).isPeriodic && !showForFixed ? "Periodic" : "Fixed "
      }}</span>
      <span matTooltip="Actual income / Planned income">Income progress: </span>
    </span>

    <span
      *ngIf="
        getTopLevelTag(node).isPeriodic && !showForFixed;
        else nonPeriodicValues
      "
    >
      <span>
        <!-- Actual -->
        <span>{{
          periodService.getActualIncomeForPeriod(node.id!) ?? 0
            | prefundCurrency
        }}</span>

        <!-- / -->
        <span class="mx-1">/</span>

        <!-- Planned -->
        <span
          (click)="plannedAmountClicked.emit(node)"
          [ngClass]="{
            'underline underline-offset-4 decoration-dotted cursor-pointer':
              withCaptions
          }"
          >{{
            getTagPeriod(node)?.plannedIncome
              ? (getTagPeriod(node)?.plannedIncome | prefundCurrency)
              : "-"
          }}</span
        >
      </span>
    </span>

    <ng-template #nonPeriodicValues>
      <!-- Non-Periodic -->
      <span
        class="whitespace-nowrap"
        *ngIf="!showForFixed; else noPlanForFixed"
      >
        <span>{{ node.actualIncome | prefundCurrency }}</span>
        <span class="mx-1">/</span>

        <span
          *ngIf="node.plannedIncome"
          [ngClass]="{
            'underline underline-offset-4 decoration-dotted cursor-pointer':
              withCaptions
          }"
          (click)="plannedAmountClicked.emit(node)"
        >
          {{ node.plannedIncome | prefundCurrency }}
        </span>
        <span *ngIf="!node.plannedIncome">-</span>
      </span>
      <ng-template #noPlanForFixed>-</ng-template>
    </ng-template>

    <span *ngIf="withCaptions" class="ml-2">
      {{ getTopLevelTag(node).isPeriodic && !showForFixed ? "Sum:" : "Sum:" }}
      <span *ngIf="!getTopLevelTag(node).isPeriodic || showForFixed">{{
        node.runningBalance | prefundCurrency
      }}</span>
      <span *ngIf="getTopLevelTag(node).isPeriodic && !showForFixed">{{
        periodService.gerRunningBalanceForPeriod(node.id!) | prefundCurrency
      }}</span>
    </span>
  </span>

  <!-- Running Balance -->
  <span *ngSwitchCase="'runningBalance'">
    <span *ngIf="withCaptions" class="align-middle">
      <tag-node-icon [node]="node" [tags]="tags"></tag-node-icon>
      Running balance:
    </span>
    <span class="whitespace-nowrap">
      <span>{{ node.runningBalance | prefundCurrency }} </span>
      <!-- <span>{{ node | json }}</span> -->
    </span>
  </span>
</span>
